import { render } from "./CardImage.vue?vue&type=template&id=28a53c8f&scoped=true"
import script from "./CardImage.vue?vue&type=script&lang=ts"
export * from "./CardImage.vue?vue&type=script&lang=ts"

import "./CardImage.vue?vue&type=style&index=0&id=28a53c8f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28a53c8f"

export default script